//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import defaultAvatar from "@/assets/images/user.svg";

export default {
    components: {

    },
    filters: {
        initials: (value) => {
            const matches = value.match(/\b(\w)/g);
            return matches.join("");
        },
        convertToLocalTime(data) {
            if (data) {
                if (data.includes("+000")) {
                    data.substring(0, data.length - 5);
                }
                if (data.includes("+00:00")) {
                    data.replace("+00:00", "");
                }
                const jsDate = new Date(data);
                const newDate = new Date(jsDate.getTime() + jsDate.getTimezoneOffset() * 60 * 1000);
                const hours = jsDate.getHours();
                newDate.setHours(hours);
                const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
                let numberMonth = newDate.getMonth() + 1; const
                    letterMonth = monthNames[newDate.getMonth()];
                numberMonth = newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1;
                let localFormattedDate = date.formatDate(newDate, "DD MM YYYY, HH:mm");
                const weekDay = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][jsDate.getDay()];
                localFormattedDate = localFormattedDate.replace(numberMonth, letterMonth);
                return `${weekDay}, ${localFormattedDate}`;
            }
            return "";
        }
    },
    props: {
        processInstance: String,
        applicationId: String
    },
    data() {
        return {
            comments: []
        };
    },
    mounted() {
        this.$store.dispatch("diagrams/getComments", { processInstance: this.processInstance, appId: this.applicationId }).then((rsp) => {
            this.comments = rsp.data;
        });
    },
    methods: {
        setImage(userId) {
            return `/identity/tenants/users/image/${userId}/l`;
        },
        replaceByDefault(e) {
            e.target.src = defaultAvatar;
        }
    }
};
